import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureToggle } from '../services';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuard implements CanLoad {
  constructor(
    private features: FeatureToggle,
    private router: Router
  ) { }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const feature = route.data?.feature;// <-- Get the module name from route data
    if (this.isFeatureEnabled(feature)) {
      return true;
    }
    this.router.navigate(['/404']);
    return false;
  }
  isFeatureEnabled(feature: string) {
    if (this.features['*']) {
      return true;
    }
    return this.features[feature];
  }
}
